<template>
  <div class="wrapper">
    <side-bar>
      <template slot="links">
        <template v-for="group in getGroups">
          <li class="nav-group-title" :key="'group-' + group.title">{{ group.title }}</li>
          <sidebar-link v-for="stats in group.items" :key="stats.to" :to="stats.to" :name="stats.name" :icon="stats.icon" />
        </template>
        <!-- <sidebar-link to="/dashboard" name="Inicio" icon="ti-home"/>
          <sidebar-link to="/usuarios" name="Usuarios" icon="ti-user" />
          <sidebar-link to="/estaciones" name="Estaciones" icon="ti-truck" />
          <sidebar-link to="/direcciones" name="Direcciones" icon="ti-book" />
          <sidebar-link to="/descargar-tareas" name="Configuración" icon="ti-settings" />
          <sidebar-link to="/tareas-estacion" name="Tareas" icon="ti-view-list-alt" />
          <sidebar-link to="/descargar-respaldo" name="Respaldos" icon="ti-cloud-down" /> -->
      </template>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>

      <dashboard-content @click.native="toggleSidebar"> </dashboard-content>

      <content-footer></content-footer>
    </div>
  </div>
</template>
<style lang="scss"></style>
<script>
import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import state from "../../store/state";
// import auth  from "../../token";
export default {
  components: {
    TopNavbar,
    ContentFooter,
    DashboardContent
  },
  data() {
    return {
      statsCards: []
    };
  },
  created() {
    this.statsCards = state.menu;
  },
  computed: {
    getRol() {
      let att = JSON.parse(localStorage.getItem('attributes'));
      let roles = [];
      for (let key in att) {
        if (att.hasOwnProperty(key)) {
          if (att[key][0] === 'false') roles.push({ id: key, value: true })
        }
      }
      return roles;
    },
    // Sidebar sections as in the eGas panel. Visibility still comes from getStats (Keycloak menu
    // attributes plus the ADMIN-only archive entry); this only orders and labels what is visible.
    getGroups() {
      const sections = [
        { title: "General", routes: ["/dashboard"] },
        { title: "Administración", routes: ["/usuarios", "/estaciones", "/direcciones"] },
        { title: "Configuración", routes: ["/descargar-tareas", "/tareas-estacion"] },
        { title: "Respaldos", routes: ["/descargar-respaldo", "/historico"] }
      ];
      const visible = this.getStats;
      const placed = new Set();
      const groups = sections.map(sec => {
        const items = visible.filter(s => sec.routes.includes(s.to));
        items.forEach(s => placed.add(s.to));
        return { title: sec.title, items };
      });
      const rest = visible.filter(s => !placed.has(s.to));
      if (rest.length) groups.push({ title: "Otros", items: rest });
      return groups.filter(g => g.items.length);
    },
    getStats() {
      const stats = [{ to: "/dashboard", name: "Inicio", icon: "ti-home" }];
      for (let i = 0; i < this.statsCards.length; i++) {
        for (let j = 0; j < this.getRol.length; j++) {
          if (this.statsCards[i].rol === this.getRol[j].id) {
            stats.push(this.statsCards[i])
          }
        }
      }
      // Archive packages are managed by ADMIN only; not a Keycloak menu attribute, so not in state.menu.
      if (localStorage.getItem('role') === 'ADMIN') {
        stats.push({ to: "/historico", name: "Histórico", icon: "ti-archive" });
      }
      return stats;
    }
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
  },
};
</script>
